// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PersonnelCostsPerCategoryDetail  {
    _originalTypeClassName = "Loom.BO.PersonnelCostsPerCategoryDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PersonnelCostsPerCategoryDetail.translate = translateService;
}
this.Id = null;
this.GATotalCosts = null;
this.LinearProjectionCostsInclPeriod = null;
this.ReportedCostsUntilPeriodStart = null;
this.PeriodCosts = null;
this.TotalReportedCostsInclPeriod = null;
this.DeviationJustification = null;
this.ECPersonnelCostsCategory = null;
this.TotalDetailCostsDeviationFromGA = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
GATotalCosts:any;
LinearProjectionCostsInclPeriod:any;
ReportedCostsUntilPeriodStart:any;
PeriodCosts:any;
TotalReportedCostsInclPeriod:any;
DeviationJustification:any;
ECPersonnelCostsCategory:any;
TotalDetailCostsDeviationFromGA:any;
CostStatement:any;
static setCostStatement = ($this, value) => {
var oldValue = $this.CostStatement;
$this.CostStatement = value;
if (value != null) {
if (oldValue != null) {
Domain.CostStatement.removePersonnelCostsDetails(oldValue, $this);
}
Domain.CostStatement.addPersonnelCostsDetails(value, $this);
}
}

static GetDetailTotalCostsDeviationFromGA($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.LinearProjectionCostsInclPeriod, () => 0))) {return (CLMS.Framework.Number.LessThanOrEqual(() => Domain.PersonnelCostsPerCategoryDetail.GetTotalReportedCostsInclPeriod($this), () => 0) ? 0 : 1);}
let deviationPercentage = Math.abs(Joove.Common.safeNumber((Joove.Common.safeNumber(Domain.PersonnelCostsPerCategoryDetail.GetTotalReportedCostsInclPeriod($this)) - Joove.Common.safeNumber($this?.LinearProjectionCostsInclPeriod))) / Joove.Common.safeNumber($this?.LinearProjectionCostsInclPeriod));
console.warn(CLMS.Framework.String.Format(" abs( {0} - {1} ) / {1} = {2} ( this.TotalReportedCostsInclPeriod = {3} )", Domain.PersonnelCostsPerCategoryDetail.GetTotalReportedCostsInclPeriod($this), $this?.LinearProjectionCostsInclPeriod, deviationPercentage, $this?.TotalReportedCostsInclPeriod));
return Joove.Common.mathRound(deviationPercentage, 2);
}
static GetTotalReportedCostsInclPeriod($this: any): any{return Joove.Common.safeNumber($this?.ReportedCostsUntilPeriodStart) + Joove.Common.safeNumber($this?.PeriodCosts);
}
static IsCostsDeviationJustificationRequired($this: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => $this.LinearProjectionCostsInclPeriod, () => 0)) {return false;}
if (!(CLMS.Framework.String.IsNullOrEmpty(($this?.DeviationJustification ?? '').trim()))) {return false;}
return CLMS.Framework.Number.GreaterThan(() => Joove.Common.safeNumber(Math.abs(Joove.Common.safeNumber($this.TotalReportedCostsInclPeriod) - Joove.Common.safeNumber($this.LinearProjectionCostsInclPeriod))) / Joove.Common.safeNumber($this.LinearProjectionCostsInclPeriod), () => 0.15);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}